import React, { memo, Fragment } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import { PopoverText } from '../../common/parts/PopoverText';
import { Alart } from "../../common/parts/Alart";
import { OptionCheckbox } from "../parts/OptionCheckbox";

import { orderState } from '../../../store/orderState';
import { optionState } from '../../../store/optionState';
import { userState } from '../../../store/userState';

export const FormOption = memo((props) => {
  const [orderData, setOrderData] = useRecoilState(orderState);
  const [optionData, setOptionData] = useRecoilState(optionState);
  const userData = useRecoilValue(userState);

  const onChangeOption = (item) => {
    let result = orderData.options.filter(option => option.option_id === item.option_id);
    if (!!result.length) {
      setOrderData({...orderData,
        options: orderData.options.filter(option => option.option_id !== item.option_id)
      });
    } else {
      const addItem = { ...item };
      addItem.mtemployee_id = userData.user_id;
      setOrderData({...orderData,
        options: [...orderData.options, addItem]
      });
    }
  }

  return (
    <>
      <p className="h3">検査オプション 
        <PopoverText textTitle="検査オプション" textBody="検査オプション。" />
      </p>
      <p className="text-danger">
        ※ 検査オプションを選択することで、自己負担金額が増えることがあります。<br />
        ※ 選択可能な検査オプションは医療機関によって変わります。
      </p>

      <div className="list-group mb-4">
      {optionData ?
        <Fragment>
          {optionData.length === 0 && <Alart type="warning" text="選択可能なオプションが存在しません。" />}
          {optionData.map(item => 
            <OptionCheckbox key={item.option_id} item={item} onChangeOption={() => onChangeOption(item)} />
          )}
        </Fragment>
      :
        <Alart type="warning" text="選択可能なオプションが存在しません。" />
      }
      </div>

      <p className="text-center h1"><i className="fas fa-chevron-down"></i></p>
    </>
  );
});